import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerInterface, PostalAddressInterface } from "../../models/customer";

@Component({
    selector: 'gea-shop-address-field',
    templateUrl: './address-field.component.html',
    styleUrls: ['./address-field.component.scss'],
    standalone: false
})
export class AddressFieldComponent {
  @Input() address?: PostalAddressInterface
  @Input() customer?: CustomerInterface
  @Output() onEdit = new EventEmitter<PostalAddressInterface>()
}
